import React, { useRef, useState } from 'react'
import { Button } from 'antd'
import $t from '../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../actions'
import Page from '../../common/Page'
import Actions from '../../../actions'
import Card from '../../common/Card'
import dayjs from 'dayjs'
import PaymentDetailsCard from '../../common/PaymentDetailsCard'
import EmptyList from '../../common/EmptyList'
import SubscriptionCard from '../../common/SubscriptionCard'

import './PaymentDetails.css'

const PaymentDetails = () => {
  const dispatch = useDispatch()
  const zouraIframeRef = useRef()
  const paymentDetails = useSelector(state => state.payment.paymentDetailsData)
  const loadingInvoiceId = useSelector(state => state.payment.loadingInvoiceId)
  const paymentAddressObj = useSelector(
    state => state.payment.paymentAddressObj
  )
  const invoices = paymentDetails?.invoices

  const [isEditableView, setIsEditableView] = useState(false)

  const onEditPaymentClick = event => {
    setIsEditableView(true)

    dispatch(
      actions.createAction(actions.GENERATE_UPDATE_PAYMENT_CARD_REQUESTED)
    )
  }

  const onRequestInvoice = (invoiceFile, invoiceId) => {
    dispatch(
      Actions.createAction(Actions.PAYMENT_INVOICE_REQUESTED, {
        invoiceFile,
        invoiceId,
      })
    )
  }

  const renderInvoices = () => {
    return (
      <Card className="payment-invoice-card">
        <div className="history-header">
          <div className="history-title semi-bold">
            {$t('pages.paymentDetails.invoice')}
          </div>
        </div>
        {!invoices?.length && (
          <EmptyList title={$t('pages.paymentsAndBilling.noInfo')} />
        )}
        {!!invoices?.length && (
          <div className="history-table">
            {invoices?.map(invoice => (
              <div className="history-table-row row" key={invoice?.id}>
                <div className="history-table-column">${invoice?.amount}</div>
                <div className="history-table-column">
                  {dayjs(invoice?.invoiceDate)?.format('MMM D, YYYY')}
                </div>
                <div className="history-table-column">
                  <Button
                    type="link"
                    loading={loadingInvoiceId === invoice?.id}
                    onClick={() =>
                      onRequestInvoice(invoice?.invoiceFile, invoice?.id)
                    }
                  >
                    {$t('pages.paymentsAndBilling.invoices.download')}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    )
  }

  const onUpdatePaymentMethodSuccess = data => {
    let cardData = {
      defaultPaymentMethodId: data.refId,
      ...paymentAddressObj,
    }
    dispatch(
      actions.createAction(
        actions.PAYMENT_METHOD_CARD_UPDATE_REQUESTED,
        cardData
      )
    )

    setIsEditableView(false)

    dispatch(
      actions.createAction(actions.ANALYTICS_EVENT_FIRED, {
        eventName: actions.ADD_PAYMENT_METHOD_SUCCEED,
      })
    )
  }

  return (
    <Page
      className="payment-details-page"
      title={$t('pages.paymentDetails.title')}
      loading={!paymentDetails}
    >
      <SubscriptionCard paymentDetails={paymentDetails} />

      <PaymentDetailsCard
        isEditableView={isEditableView}
        onEdit={onEditPaymentClick}
        zouraIframeRef={zouraIframeRef}
        onSuccess={onUpdatePaymentMethodSuccess}
        isManagePayment={true}
        onCancel={() => setIsEditableView(false)}
        SubmitButtonText={$t('pages.billing.continuePayment')}
      />

      {renderInvoices()}
    </Page>
  )
}

export default PaymentDetails
